import Dialog from "../../../atoms/dialog";
import { useState } from 'react'
import AddClusterletNodes from '../../transactions/AddClusterlets';
import React from 'react'

const AddClusteretsAlert = (props) => {
    const {transactionNodes, transaction,  onClose, onCompletion } = props;
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog
            title={"Add clusterlets"} 
            open={true}
            handleClose={handleClose}
            paperProps={{ style: { width: 1000, maxWidth: 1500 } }}
        >
            <AddClusterletNodes transaction={transaction} existingNodes={transactionNodes} onClose={onClose} onCompletion={onCompletion} />
        </Dialog >
    )
}

export default AddClusteretsAlert